export default __webpack_public_path__ + "static/logo-manifest-dark-9d9320cad35eddf26e222608366aff17.png";